import { render, staticRenderFns } from "./PhuConfigCard.vue?vue&type=template&id=14f703cc&scoped=true"
import script from "./PhuConfigCard.vue?vue&type=script&lang=js"
export * from "./PhuConfigCard.vue?vue&type=script&lang=js"
import style0 from "./PhuConfigCard.vue?vue&type=style&index=0&id=14f703cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f703cc",
  null
  
)

export default component.exports